import { Box, Divider, Stack, Typography } from "@mui/material"
import { FC, ReactNode } from "react"

/**
 * One consistent frame for the page's top-level blocks.
 *
 * The page previously mixed Cards, Papers and bare Stacks at different widths,
 * so nothing lined up and every block claimed a different amount of visual
 * weight. A single heading + rule keeps the two working columns readable as
 * peers.
 */
export const SaLockerSection: FC<{
  title: string
  hint?: string
  action?: ReactNode
  children: ReactNode
  /** `data-ui` surface id (dev/ecosystem/ui/sl2-console.md). */
  ui?: `UI-SL2W-${string}`
}> = ({ title, hint, action, children, ui }) => (
  <Box component="section" data-ui={ui}>
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: hint ? 0.5 : 1 }}>
      <Typography variant="subtitle2" fontWeight={600}>
        {title}
      </Typography>
      <Box sx={{ flex: 1 }} />
      {action}
    </Stack>
    <Divider sx={{ mb: hint ? 1 : 2 }} />
    {hint && (
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        sx={{ mb: 2, maxWidth: "70ch" }}
      >
        {hint}
      </Typography>
    )}
    {children}
  </Box>
)

export default SaLockerSection
